export default __webpack_public_path__ + "21d2111dd61e7e7b7c0e7f33ea086261.png";